import { render, staticRenderFns } from "./DimensionChart.vue?vue&type=template&id=2fefaaef&"
import script from "./DimensionChart.vue?vue&type=script&lang=js&"
export * from "./DimensionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports